import { render, staticRenderFns } from "./MPNResearchDetailResult.vue?vue&type=template&id=6fd233ea&scoped=true"
import script from "./MPNResearchDetailResult.vue?vue&type=script&lang=js"
export * from "./MPNResearchDetailResult.vue?vue&type=script&lang=js"
import style0 from "./MPNResearchDetailResult.vue?vue&type=style&index=0&id=6fd233ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd233ea",
  null
  
)

export default component.exports